import { type FC, type PropsWithChildren, createContext, useCallback, useContext, useState } from 'react';

// Comparte el estado de "sidebar expandido/colapsado" entre <Sidebar />
// y <Screen /> (que renderiza el contenido). Antes cada uno tenía su
// propio valor: el sidebar gestionaba su ancho real (80px/288px) con
// estado local, mientras que Screen desplazaba el contenido con un
// margen fijo (60px) que no coincidía con ninguno de los dos anchos
// reales. Con este contexto ambos leen el mismo `isOpen` y el
// contenido se ajusta de verdad al ancho visible del sidebar.

interface ISidebarContext {
  isOpen: boolean
  toggleSidebar: () => void
}

const SidebarContext = createContext<ISidebarContext>({
  isOpen: false,
  toggleSidebar: () => {}
});

export const SidebarProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return (
    <SidebarContext.Provider value={{ isOpen, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
